const LINE_BREAK_TOKENS = /<1>|<br\s*\/?>/gi;

export const withLineBreaks = (value: string): string =>
  value.replace(LINE_BREAK_TOKENS, '\n');
